// extracted by mini-css-extract-plugin
module.exports = {"userPersonalInfo__Container":"UserProfile_userPersonalInfo__Container__h0wlr","tableTitle":"UserProfile_tableTitle__1wY7m"};